import { Box, Divider, SimpleGrid, Space, Title } from '@mantine/core'
import React, { memo } from 'react'
import DataPieChart from '../../ComputeLca/NewLCA/CategoryComponent/LCAReport/PieChart/PieChart.component';
import LcaTableComponent from '../../ComputeLca/NewLCA/CategoryComponent/LCAReport/LcaTable/LcaTable.component';


const LcaReport = ({ value }: any) => {

    const data = value;
    return (
        <>
            <Space h="lg" />
            <Title order={4}>Report</Title>
            <Space h="lg" />
            <Divider h={'sm'} />
            <SimpleGrid
                cols={{ base: 1, xs: 1, sm: 2, md: 2, lg: 2 }}
            >
                <Box><DataPieChart data={data} /></Box>
                <Box style={{ width: '100%' }}><LcaTableComponent data={data} /></Box>
            </SimpleGrid>
        </>
    )
}


export default memo(LcaReport);